export const DISCOUNT_CODES = {
  L: 0.7,
  M: 0.65,
  N: 0.6,
  O: 0.55,

  A: 0.5,
  P: 0.5,

  B: 0.45,
  Q: 0.45,

  C: 0.4,
  R: 0.4,

  D: 0.35,
  S: 0.35,

  E: 0.3,
  T: 0.3,

  F: 0.25,
  U: 0.25,

  G: 0.2,
  V: 0.2,

  H: 0.15,
  W: 0.15,

  I: 0.1,
  X: 0.1,

  Y: 0.05,
  J: 0.05,

  Z: 0,

  0: 0
};
